module.exports = __webpack_public_path__ + "static/img/subtract.99ff8e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/subtract.png
// module id = Cb5M
// module chunks = 2